import {Component, Input, OnInit} from '@angular/core';
import {AbstractQuoteRow} from '../../abstract-quote-row';
import {AssetRisk} from '../../../../class/result/safeguard/asset-risk';
import {Person} from '../../../../class/person';

@Component({
  selector: 'app-asset-risk-row',
  templateUrl: './asset-risk-row.component.html',
  styleUrls: ['./asset-risk-row.component.css']
})
export class AssetRiskRowComponent extends AbstractQuoteRow<AssetRisk> implements OnInit {

  @Input()
  assetRisk: AssetRisk;

  constructor() {
    super();
  }

  ngOnInit() {
    this.selectedCover = this.assetRisk.totalRiskValue;
  }

  getRowObject(): AssetRisk {
    return this.assetRisk;
  }
}
